import { parseAcademicYear } from './academicYear';

export const intersectAcademicYearOptions = (configuredYears, allowedOptions) => {
  const configuredStorageYears = new Set(
    (Array.isArray(configuredYears) ? configuredYears : []).flatMap((value) => {
      try {
        return [parseAcademicYear(value).storage];
      } catch (error) {
        return [];
      }
    })
  );

  return [...allowedOptions]
    .filter(({ storage }) => configuredStorageYears.has(storage))
    .sort((first, second) => first.startYear - second.startYear);
};
